<section class="tarjeta-producto">
	<a [routerLink]="['/producto', identificador]">
		<figure>
			<div>
				<img [src]=" fnGetImage() " [alt]="newProducto.nombre" loading="lazy"/>
			</div>
		</figure>
		<figcaption>
			<div class="nombre-producto text-break">
				<p class="color-black-bold">
					{{ newProducto.nombre }}
				</p>
			</div>
			<div class="precio-producto">
				<p>
					<span class="color-blue-bold" *ngIf=" !newProducto.hasDescuento ">
						{{ newProducto.precio | currency:newProducto.divisa:'symbol':'.2-2' }}
					</span>
					<span class="producto-descuento" *ngIf=" newProducto.hasDescuento ">
						<span class="color-blue-bold">
							{{ (newProducto.precio - newProducto.descuento) | currency:newProducto.divisa:'symbol':'.2-2' }}
						</span>
						<span>
							<small>{{ newProducto.precio | currency:newProducto.divisa:'symbol':'.2-2' }}</small>
						</span>
					</span>
				</p>
			</div>
			<div class="descripcion-producto text-break">
				<p>{{ newProducto.descripcion }}</p>
			</div>
		</figcaption>
	</a>
</section>